// extracted by mini-css-extract-plugin
export default {"details":"G-rvPWO8fR","code-editor":"VjHniSsVTk","codeEditor":"VjHniSsVTk","event-type":"hj8rU5McW6","eventType":"hj8rU5McW6","event-description":"uQJvTU2TNV","eventDescription":"uQJvTU2TNV"};
    if(module.hot) {
      // 1648554210632
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  